import Input from "../Input/Input";
import { toIsoDate } from "../../../dates";

interface DatePickerProps {
	/** Any ISO value. A time component, if there is one, is dropped */
	value?: string | number | null;
	min?: string | number | null;
	max?: string | number | null;
	error?: boolean;
	onChange: (date: string | null) => void;
}

/**
 * Wraps the native date picker. Everything in and out is a plain ISO date, so a column whose bounds are
 * timestamps still filters on whole days.
 */
export default function DatePicker({ value, min, max, error, onChange }: DatePickerProps) {
	return (
		<Input
			type="date"
			value={toIsoDate(value) ?? ""}
			min={toIsoDate(min)}
			max={toIsoDate(max)}
			error={error}
			onChange={(e, data) => onChange(toIsoDate(data.value) ?? null)}
		/>
	);
}
